import React, { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import MySearchIcon from '../MySearchIcon';
import { useToast } from 'use-toast-mui';
import { useForm } from 'react-hook-form';
import { FormInputText } from '../../form-components/FormInputText';
import { FormInputDate } from '../../form-components/FormInputDate';
import { FormInputRadio } from '../../form-components/FormInputRadio';
import { gender, scriptUrl, smsAgreement } from '../../constants/constants';
import { converterJsonToFormData, errorMessages, removeEmptyValues } from '../../utils/methods';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FormInputPhone } from '../../form-components/FormInputPhone';
import { useSelector } from 'react-redux';
import { getUserById, updateUserById } from '../../api/user';
import moment from 'moment/moment';

const MembersDetail = () => {
  const date = new Date();
  const toast = useToast();
  const { t } = useTranslation();
  const { token } = useSelector(state => state.user.user);
  const navigate = useNavigate();
  const {
    control,
    setValue,
    reset,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [previewImage, setPreviewImage] = useState();
  const [address, setAddress] = useState('');
  const [birthDate, setBirthDate] = useState(null);
  const [age, setAge] = useState(null);
  const currentYear = date.getFullYear();
  const handleAge = useRef(() => {});
  const { id } = useParams();

  handleAge.current = birthYear => {
    const result = currentYear - birthYear;
    setAge(result);
  };

  const open = useDaumPostcodePopup(scriptUrl);

  const watchedFields = watch();

  const getUser = async () => {
    try {
      const user = await getUserById(id, token);

      reset({ ...user });

      setPreviewImage(user?.authImage);

      // setUser(user);
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const handleComplete = data => {
    let fullAddress = data.address;
    let extraAddress = '';

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
    }
    setAddress(fullAddress, 'address data');
    setValue('address', fullAddress);
    setValue('postalCode', data.zonecode);
  };

  const handleClick = () => {
    open({ onComplete: handleComplete });
  };

  const handleUploadImage = e => {
    setPreviewImage(e.target.files[0]);
  };

  useEffect(() => {
    if (birthDate) {
      handleAge.current(birthDate.$y);
    }
  }, [birthDate, age]);

  useEffect(() => {
    setValue('isSMSReceive', true);
    setValue('gender', 'MALE');
    getUser();
  }, []);

  const submit = async values => {
    if (values.password !== values.verifyPassword) {
      return setError('verifyPassword', {
        type: 'custom',
        message: t('Password not matched'),
      });
    }

    if (values.birthDate) {
      const formattedDate = moment(values.birthDate).format('YYYY-MM-DD');
      values.birthDate = formattedDate;
    }

    // profileImage, authImage 제외
    const { profileImage, authImage, ...valuesWithoutImage } = values;

    const formData = converterJsonToFormData(
      removeEmptyValues({
        ...valuesWithoutImage,
      }),
    );

    try {
      await updateUserById(formData, memberId);
      navigate('/members');
      toast.success(t('Member information has been modified'));
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const password = watch('password');

  const memberId = watch('memberId');

  const loginType = watch('loginType');

  const switchLoginType = value => {
    switch (value) {
      case 'K':
        return '카카오계정';
      case 'A':
        return '애플계정';
      case 'N':
        return '네이버계정';
      case 'G':
        return '구글계정';
      case 'B':
        return '일반로그인';
      default:
        return '-';
    }
  };

  return (
    <div
      style={{
        background: 'white',
        borderRadius: '5px',
        padding: '40px',
        width: '1480px',
      }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
        <Link to="/members" style={{ textDecoration: 'none', color: '#3a3a3a', display: 'flex' }}>
          <svg id="뒤로가기" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path id="Path_6534" data-name="Path 6534" d="M0,0H24V24H0Z" fill="none" />
            <circle
              id="Ellipse_96"
              data-name="Ellipse 96"
              cx="11"
              cy="11"
              r="11"
              transform="translate(1 1)"
              fill="#3a3a3a"
            />
            <path
              id="Path_6535"
              data-name="Path 6535"
              d="M6.393,8.579H14V9.865H6.393l3.352,3.448-.884.909L4,9.222l4.861-5,.884.909Z"
              transform="translate(3 2.778)"
              fill="#fff"
            />
          </svg>

          <Typography
            sx={{
              fontSize: '18px',
              lineHeight: '22px',
              ml: '8px',
              fontWeight: '550',
            }}>
            {t('Add Client')}
          </Typography>
        </Link>

        <Link
          style={{
            color: '#0F7F85',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: 550,
          }}
          to="/members">
          {t('List')}
        </Link>
      </Box>
      <hr />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { sm: '1.3fr 3fr 3fr' },
          gap: 1,
          background: '#fafbfc',
        }}
        className="form1">
        <Box>
          {previewImage ? (
            <img
              src={previewImage.startsWith('data:') ? previewImage : `data:image/png;base64,${previewImage}`}
              alt="uploaded"
              width="116px "
              height="116px"
              style={{
                objectFit: 'cover',
                marginLeft: '50px',
                marginTop: '75px',
                borderRadius: '50%',
              }}
            />
          ) : (
            <label htmlFor="imageupload">
              <Box position="relative" sx={{ '&:hover': { cursor: 'pointer' } }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginLeft: '45px',
                    marginTop: '60px',
                  }}>
                  <img
                    style={{
                      width: '116px',
                      height: '116px',
                      objectFit: 'cover',
                      borderRadius: '50%',
                    }}
                    src={
                      previewImage
                        ? (window.URL || window.webkitURL).createObjectURL(previewImage)
                        : '/images/profile@2x.png'
                    }
                    alt="avatar"
                  />
                </div>
              </Box>
              <input
                type="file"
                disabled
                accept="image/*"
                id="imageupload"
                style={{ display: 'none' }}
                // onChange={handleUploadImage}
              />
            </label>
          )}
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '30px',
          }}>
          <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
            {t('Name*')}
          </Typography>
          <FormInputText
            color="info"
            control={control}
            rules={{ required: true }}
            size="small"
            fullWidth
            variant="outlined"
            name="name"
            placeholder={t('Please enter your name')}
          />
          <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
            {t('Phone number*')}
          </Typography>
          <FormInputPhone
            control={control}
            rules={{ required: true }}
            setValue={setValue}
            name="phoneNumber"
            placeholder={t('Enter your phone number')}
          />

          <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
            {t('E-mail*')}
          </Typography>
          <FormInputText
            color="info"
            control={control}
            rules={{ required: true }}
            type="email"
            size="small"
            fullWidth
            variant="outlined"
            name="email"
            placeholder={t('Enter your E-mail address')}
          />
          {/*<Typography sx={{ fontSize: '12px', fontWeight: 500, color: '#0F7F85' }} className="input-label">
            {t('Client Number​')}
          </Typography>
          <FormInputText
            color="info"
            control={control}
            rules={{ required: true }}
            size="small"
            fullWidth
            variant="outlined"
            name="memberId"
            placeholder={t('Please enter your name')}
            disabled={true}
          />*/}
          <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
            {t('Date of Birth')}
          </Typography>
          {/*<FormInputDate
            name="birthDate"
            control={control}
            rules={{ required: true }}
            disabled={true}
            placeholder={t('DD/MM/YYYY')}
            renderInput={params => (
              <TextField
                sx={{
                  '& .MuiSvgIcon-root': {
                    fill: '#0F7F85 !important',
                  },
                }}
                size="small"
                {...params}
              />
            )}
          />*/}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}>
            <FormInputDate
              name="birthDate"
              control={control}
              placeholder={t('DD/MM/YYYY')}
              variant="outlined"
              renderInput={params => (
                <TextField
                  size="small"
                  variant="outlined"
                  {...params}
                  sx={{
                    flex: 1,
                    background: '#fff',
                    '& .css-i4bv87-MuiSvgIcon-root': {
                      fill: '#0F7F85 !important',
                    },
                  }}
                />
              )}
            />
            <p
              style={{
                color: '#0F7F85',
                fontWeight: 'bold',
                margin: '0 10px',
                fontSize: '15px',
              }}>
              {watchedFields.age}
            </p>
          </div>
          <Box sx={{ display: 'flex', alignItems: 'center', mt: '18px', userSelect: 'none', pointerEvents: 'none' }}>
            <Typography
              sx={{
                width: '22.5%',
                color: '#0F7F85',
                fontSize: '12px',
                fontWeight: 500,
              }}>
              {t('Gender')}
            </Typography>
            <FormInputRadio name="gender" control={control} options={gender} sx={{ ml: '24px' }} row />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography
              sx={{
                width: '22.5%',
                color: '#0F7F85',
                fontSize: '12px',
                fontWeight: 500,
              }}>
              {t('Agree to receive SMS')}
            </Typography>
            <FormInputRadio name="isSMSReceive" control={control} options={smsAgreement} sx={{ ml: '24px' }} row />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            padding: '30px ',
          }}>
          <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
            {t('ID*')}
          </Typography>
          <FormInputText
            color="info"
            control={control}
            rules={{ required: true }}
            disabled={true}
            size="small"
            fullWidth
            variant="outlined"
            name="username"
            placeholder={t('Enter your ID')}
          />
          <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
            {t('Password')}
          </Typography>
          <FormInputText
            color="info"
            control={control}
            type="password"
            size="small"
            fullWidth
            variant="outlined"
            name="password"
            // disabled={props.user.loginType!=='B'}
            rules={{
              pattern: {
                value: /^.{4,16}$/u, // 회원앱 비밀번호 규칙(서버 AppPasswordRule) — 4~16자, 조합 제한 없음(2026-10-28)
                message: t(
                  '비밀번호는 4~16자로 입력해 주세요.',
                ),
              },
            }}
            placeholder={t(
              '4~16자',
            )}
          />
          <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
            {t('Confirm Password')}
          </Typography>
          <FormInputText
            control={control}
            type="password"
            name="verifyPassword"
            // disabled={props.user.loginType!=='B'}
            rules={{
              validate: value => value === password || '비밀번호가 일치하지 않습니다',
            }}
            placeholder={t(
              '4~16자',
            )}
          />
          <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
            {t('Login Type')}
          </Typography>
          <FormInputText
            color="info"
            control={control}
            size="small"
            disabled
            fullWidth
            variant="outlined"
            staticValue={switchLoginType(loginType)}
            placeholder={t('Login Type')}
          />
          <Box
            sx={{
              display: 'grid',
              rowGap: 1,
            }}>
            <Typography sx={{ color: '#0F7F85', fontSize: '12px', fontWeight: 500 }} className="input-label">
              {t('Address')}
            </Typography>
            <FormInputText
              control={control}
              onMouseOver={e => (e.target.style.cursor = 'pointer')}
              color="info"
              name="address"
              value={address}
              disabled={true}
              placeholder={t('Mailing Address*')}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <p
                      style={{
                        color: '#A1A1A1',
                        margin: '0 14px 0 0',
                        fontSize: '10px',
                      }}>
                      {t('City, State or ZIP Code')}
                    </p>
                    <MySearchIcon onClick={handleClick} />
                  </InputAdornment>
                ),
              }}
            />
            <FormInputText
              color="info"
              control={control}
              type="roadAddress"
              size="small"
              fullWidth
              variant="outlined"
              name="addressDetail"
              placeholder={t('Address details')}
              disabled={true}
            />
          </Box>
        </Box>

        <Box />
        <Box sx={{ ml: 4 }}></Box>
      </Box>

      <hr style={{ border: '1px solid #e1e1e1' }} />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 3,
          mb: 3,
        }}>
        <Button
          onClick={() => navigate(-1)}
          sx={{
            borderRadius: '12px',
            pl: '35px',
            pr: '35px',
            mr: '6px',
            height: '36px',
            background: '#f7f7f7',
            color: '#9a9a9a',
            border: 'none',
            '&:hover': { background: '#ddd', cursor: 'default' },
          }}>
          {t('Cancel')}
        </Button>

        <Button
          onClick={handleSubmit(submit)}
          sx={{
            borderRadius: '12px',
            pl: '50px',
            pr: '50px',
            height: '36px',
            background: '#faf7fe',
            '&:hover': {
              background: '#0F7F85',
              color: '#fff',
              cursor: 'default',
            },
          }}>
          {t('Save')}
          {/*<Button
          onClick={() => navigate(-1)}
          sx={{
            borderRadius: '5px',
            pl: '35px',
            pr: '35px',
            mr: '6px',
            height: '36px',
            background: '#0F7F85',
            border: '1px solid #0F7F85',
            color: '#fff',
            '&:hover': { background: '#fff', cursor: 'pointer', color: '#0F7F85' },
          }}>
          {t('확인')}*/}
        </Button>
      </Box>
    </div>
  );
};

export default MembersDetail;
